export default __webpack_public_path__ + "static/media/active-clock-icon-morgan.299adb8bf53b52e59e74dfcc6d8cf28f.svg";